import classNames from "classnames";
import React from "react";

export const BankConnectionStatus = ({
  connected,
  isClosed,
}: {
  connected: boolean;
  isClosed: boolean;
}) => {
  if (isClosed) {
    return (
      <div className="t-px-2 t-py-1 t-rounded-xl t-flex t-gap-1 t-items-center t-w-fit t-bg-neutral-0">
        <div className="t-h-1.5 t-w-1.5 t-rounded-full t-bg-neutral-70"></div>
        <div className="t-text-body-sm t-text-neutral-70">Closed</div>
      </div>
    );
  }

  return (
    <div
      className={classNames(
        "t-px-2 t-py-1 t-rounded-xl t-flex t-gap-1 t-items-center t-w-fit",
        {
          "t-bg-dark_green-10": connected,
          "t-bg-red-10": !connected,
        }
      )}
    >
      <div
        className={classNames("t-h-1.5 t-w-1.5 t-rounded-full", {
          "t-bg-dark_green-70": connected,
          "t-bg-red": !connected,
        })}
      ></div>
      <div
        className={classNames("t-text-body-sm", {
          "t-text-dark_green-70": connected,
          "t-text-red": !connected,
        })}
      >
        {connected ? "Connected" : "Disconnected"}
      </div>
    </div>
  );
};
